module.exports = __webpack_public_path__ + "0af0fbc5e9b0fa103c6953ec6fd1e8cb.gif";